import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useBackgroundUrl } from '@/components/workshop/useWorkshopImg';
import { WorkShopButton } from './type';


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as { type: WorkShopButton }

_useCssVars(_ctx => ({
  "0fb8ed82": (_unref(shareBtn).mobile),
  "1ae59b46": (_unref(shareBtn).tablet),
  "0fdfdad3": (_unref(shareBtn).pc),
  "b22ba80e": (_unref(getBtn).mobile),
  "9bd24c86": (_unref(getBtn).tablet),
  "1668ecca": (_unref(getBtn).pc)
}))



const { shareBtn, getBtn } = useBackgroundUrl();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['btn', `btn--${props.type}`])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})